import { graphql } from "src/graphql/generated";

export const onCampaignUpdateSubscription = graphql(/* GraphQL */ `
    subscription OnCampaignUpdate($campaignId: String!) {
        onCampaignUpdate(campaignId: $campaignId) {
            campaignId
            reason
        }
    }
`);
